const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export function createRequestTypes(base) {
  return [
    `${base}_${REQUEST}`,
    `${base}_${SUCCESS}`,
    `${base}_${FAILURE}`,
  ].reduce((acc, type) => {
    acc[type] = type; // eslint-disable-line no-param-reassign
    return acc;
  }, {});
}

export function createAction(type, payload = {}) {
  return { type, ...payload };
}

export const actionTypes = {
  GET_USER_PROFILE: 'GET_USER_PROFILE',
};

export function getUserProfile() {
  return {
    type: actionTypes.GET_USER_PROFILE,
    payload: {}
  };
}
